import { DayOff } from 'features/dayOff';
import { useTitle } from '../helpers';

/**
 * @page DayOffPage page
 */
const DayOffPage = () => {
  useTitle('Отгулы');

  return (
    <div>
      <DayOff />
    </div>
  );
};

export default DayOffPage;
